import ReactToPdf from "react-to-pdf";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import Moment from "moment";
import logo from "./images/loading.gif";
import Mymodal from './modal';
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
const pagestyle='{ size: 200  297mm }';
export default class MedicalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            myitems: [],
            isLoaded: false,
            ErrMsg2:"",
            ErrMsg:<img src={logo} alt=""/>,
            months: ["","January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "Novermber","December"]
        }
        this.currencyFormat = this.currencyFormat.bind(this);
      }
    currencyFormat(num) {
        let cnum=Number(num);
            return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
     }
    componentDidMount(){

        if(typeof this.props.location.data !== "undefined")
        { 
            let claimid = this.props.location.data["ClaimID"];
            let functionpath ="";
            if(cookies.get("LoginID"))
            {   
                document.body.style.cursor="wait";
                let EmpId = cookies.get("LoginID");
                if(this.props.location.data["st"]==="P")
                {
                    functionpath =cookies.get("phpclass")+'/index.php/user/medicalFormPrevious/'+claimid
                }
                else
                    functionpath =cookies.get("phpclass")+'/index.php/user/medicalForm/'+claimid
                axios({
                    method: 'post',
                    url: functionpath,
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                .then((response)=> {
                    if(response.data.length == 0)
                    {
                        this.setState({errormsg:"No record found"});
                        document.body.style.cursor="default";
                    }
                    else
                    {
                        console.log(response.data);
                        document.body.style.cursor="default";
                        let input = this.state.input;
                        input["Name"] = response.data[0]["NAME"];
                        input["Designation"] = response.data[0]["DESIG"];
                        input["Emp_ID"] = response.data[0]["Emp_Id"];
                        input["Company_Name"] = response.data[0]["company_name"];
                        input["Location"] = response.data[0]["location"];
                        input["DateClaim"] = response.data[0]["DateClaim"];
                        input["ClaimID"] = claimid;
                        input["Ceiling"] = response.data[0]["Ceiling"];
                        input["Remaining"]=response.data[0]["Remaining"];
                        this.setState(input);
                        this.setState({isLoaded: true, myitems: response.data, ErrMsg:""});
                    }
                })
                .catch=()=> {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});

                }; 
            }
        }
        else
        {
            this.props.history.push({pathname: '/MedicalClaimList'});
        }

    }
    render(){
        if(this.state.isLoaded)
        {
            let fileName=this.state.input["ClaimID"]+"-medical.pdf";
            let items=this.state.myitems;
            let CDate,MDate,TDate = "";
            let CAmt = 0;
            let MAmt = 0;
            let TAmt = 0;
        return (
            <div className="container1">
                <div style={{width:"100%"}}>
                <br></br>
                <div className="inner-profile" id="DReport" name="DReport"  ref={ref}>
                <div style={{ width:"98%",paddingLeft:"0%",margin:"2px auto",textAlign:"center"}} ref={el => (this.componentRef = el)} >
                    <h3>{this.state.input["company_name"]}</h3>
                    <h5>Medical Reimbursement Form</h5>
                    <br></br>

                <div style={{width:"100%",marginLeft:"0px",textAlign:"left"}} >
                    <table className="mtable">
                        <tbody>
                        <tr>
                        <td style={{width:"200px",fontSize:"12",fontStyle:"normal",fontFamily:"tahoma"}}>Claim ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{this.state.input["ClaimID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>Employee's ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{this.state.input["Emp_ID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>Employee's Name:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{this.state.input["Name"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>Designation:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{this.state.input["Designation"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>Location:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{this.state.input["Location"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>Date:</td>
                        <td style={{width:"300px",textAlign:"left",fontStyle: "normal",fontSize:"12",fontFamily:"tahoma"}}>{Moment(this.state.input["DateClaim"]).format("DD/MM/YYYY")}</td>
                        </tr>
                        </tbody>
                    </table>
                    <b>   
                    <span style={{width:"200px"}}>Ceiling  : {this.currencyFormat(this.state.input["Ceiling"])}</span><span style={{width:"400px",marginLeft:"50px"}}>Remaining: {this.currencyFormat(this.state.input["Remaining"])}</span></b>

                    <table className="mtable">
                        <thead >
                            <tr>
                                <th className="mth" rowSpan="2" ><p style={{textAlign:'left'}}>PATIENT NAME</p></th>
                                <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>CONSULTATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
                                <th className="mth" colSpan="2" rowSpan="2"><p style={{textAlign:'center'}}>TOTAL</p></th>
                            </tr> 

                            <tr>
                                <th className="mth" >Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((x, i) => {
                            CAmt += Number(x.Const_amt);
                            TAmt += Number(x.Test_amt);
                            MAmt += Number(x.Med_amt);
                            if(Number(x.Const_amt) === 0) 
                                CDate= "-";
                            else
                                CDate=Moment(x.Const_date).format("DD/MM/YYYY")
                            if(Number(x.Med_amt) === 0) 
                                MDate= "-";
                            else
                                MDate=Moment(x.Med_date).format("DD/MM/YYYY")
                            if(Number(x.Test_amt) === 0) 
                                TDate= "-";
                            else
                                TDate=Moment(x.Test_date).format("DD/MM/YYYY")
                                return(
                                    <tr key={i} height="40px">
                                        <td className="mtdleft" >
                                            {x.PName}
                                        </td>
                                        <td className="mtdcenter">
                                            {x.Relation}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Const_amt)}                
                                        </td>
                                        <td className="mtdcenter">
                                            {CDate}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Med_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {MDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(x.Test_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {TDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(Number(x.Const_amt)+Number(x.Med_amt)+Number(x.Test_amt))}
                                        </td>
                                    </tr>
                                );
                                })}            
{/*}                        </tbody>*/}
                        <tr style={{height:"40px", border: "1.5px solid rgb(161, 159, 159)"}}>
                            <td className="mtdleft2" colSpan="2">
                                TOTAL
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(CAmt)}                
                            </td>
                            <td className="mtdcenter2" colSpan="2" >
                                {this.currencyFormat(MAmt)}
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(TAmt)}
                            </td>
                            <td className="mtdright2" colSpan="3">
                                {this.currencyFormat(Number(CAmt)+Number(MAmt)+Number(TAmt))}
                            </td>
                        </tr>
                        <tr height="40px"></tr>
                        <tr height="120px" width="100vw">
                            <td className="mtdcenterH" rowSpan="10" colSpan={2}  >REQUESTED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan={3}>CHECKED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan={4} >APPROVED BY</td>
                        </tr> 
                        </tbody>

                    </table>
                    <font className="Pclass"><br></br>
                    <span style={{height:"100px"}}>Please attach all original Doctor's prescriptions and receipt. All amounts should be rounded to the nearest rupee.</span><br></br><br></br>
                    <label>REMARKS:_____________________________________________</label><br></br><br></br>
                    </font>
                </div>
            </div>
    </div>
    <div style={{textAlign:"center",width:"70%",marginTop:"10px", marginleft: "5%",paddingLeft:"50px"}} >
                <ReactToPdf targetRef={ref} filename={fileName} x={10} y={5} scale={0.94}>
                    {({toPdf}) => (
                    <button onClick={toPdf} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)",width:100}}>Download pdf</button>
                    )}
                </ReactToPdf>
                <ReactToPrint content={() => this.componentRef} >
                <PrintContextConsumer>
                    {({ handlePrint }) => (
                        <button onClick={handlePrint} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%", width:100}}>Print!</button>
                    )}
                </PrintContextConsumer>
            </ReactToPrint>                
        </div>

    </div>
    <br></br>
    </div>
    );
    }
    else
    {
        return(
            <div className="container1">
            <div className="center">
                {this.state.ErrMsg}
            </div>
            </div>
        );
    }
}
}